<template>
  <a @click="goDetail(info.id)" class="ab">
    <div class="itme">
      <div class="itemImg">
        <img :src="info.picPath" style />
        <!--<div>
          <div v-if="info.hasReport">质量检测报告</div>
          <div v-if="info.hasQEReport" @click="open(info.hasQEReport,info.id,$event)">质量安全报告</div>
          <div v-if="info.hasWarranty">联合质保书</div>
          <div v-if="info.hasTracking">项目追踪</div>
        </div>-->
      </div>
      <div style="padding-right: 20px;height:167px;">
        <h4>{{info.title}}</h4>
        <span class="JJe">案例简介：{{info.desc}}</span>
        <span class="JJe GCh" style="height:15px;margin-top:12px;">工程规模：{{info.scale}}</span>
        <span class="JJe GQi"  style="height:15px;">工程周期：{{info.cycle}}</span>
        <div style="margin-top: 11px;">
          <span class="JCe_bo" v-if="info.hasReport"><span class="JCe"></span><span>质量检测报告</span></span>
          <span class="an_bo" v-if="info.hasQEReport" @click="open(info.hasQEReport,info.id,$event)"><span class="an"></span><span>质量安全报告</span></span>
        </div>
        
      </div>
      <div class="look">查看详情</div>
    </div>
    <div v-show="dialogVisible" @click="clickBox($event)" class="cover">
      <div>
        <i
          style="font-size:35px;color:#ffffff;position: absolute;top: -20px;right: -45px; "
          class="el-icon-error"
          @click="down"
        ></i>
        <div class="Box">
          <div>
            <h3 class="title">质量安全报告</h3>
            <div v-for="(value,index) in CaseDetailList" :key="index" class="yearBox">
              <!--一年的-->
              <h3 style="color:#383838;margin: 15px 0 5px 0;">{{value.year}}年</h3>
              <div>
                <table>
                  <tr v-for="(value) in value.eqs" :key="value.Id">
                    <router-link :to="{path:'/originality/postDetails/'+value.Id}" target="_blank">
                      <td class="time">{{`${value.CreatedTime[1]}月${value.CreatedTime[2]}日`}}</td>
                      <td class="explain">{{value.Name}}</td>
                      <td class="ZLAQScore">质量安全：{{value.ZLAQScore}}</td>
                      <td class="CLAQScore">材料安全：{{value.CLAQScore}}</td>
                    </router-link>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </a>
</template>
<script>
import { getCaseDetail } from "../../../../../../api/index.js"

export default {
  name: 'product-item',
  data() {
    return {
      a: [],
      dialogVisible: false,//是否显示弹框
      CaseDetailList: []
    }
  },
  props: ['info'],
  methods: {
    down() {
      this.dialogVisible = !this.dialogVisible;//切换弹框显示状态
    },
    open(has,id,e) {
      // if(has){
      //   console.log('彈窗')
      //   this.dialogVisible = true
      //   e.stopPropagatio()
      // }
      if (e && e.stopPropagation) {
        this.dialogVisible = true
        e.stopPropagation();
      }
      this.$axios.post('/Api/Case/Detail/'+id).then(resp => {
        let res = resp.data
      if (res.Type == 'Success') {//成功接收的返回的数据
        //将数据存起来（data里面）
        let qe = res.Data.qe;
        //将YYYY-MM-dd hh:mm:ss的时间格式拆分成[YYYY,MM,dd,hh,mm,ss]数组
        qe = qe.map(value => {
          value.CreatedTime = value.CreatedTime.split(/[- :]/);
          return value;
        });

        //将qe里面的数据按年再次分组
        let result = [];
        //result期望结构如下
        /*[
            {
                year: "YYYY",
                qes:[qe]
            }
        ]*/
        qe.filter((value, index) => {
          //判断result是否已经包含该年的分组
          let exist = false;//默认不存在
          for (let i = 0; i < result.length; i++) {
            if (result[i].year === value.CreatedTime[0]) {//已经存在分组
              //将当前项加入该分组
              result[i].eqs.push(value);
              exist = true;//存在
              break;
            }
          }
          if (!exist) {//不存在，向result中加入该分组
            result.push({ year: value.CreatedTime[0], eqs: [value] })
          }
        });

        //对result进行第一层排序（年）
        result.sort(function (a, b) {
          return (+b.year) - (+a.year)
        });
        //对result进行第一层排序（月，日，时，分，秒）
        for (let i = 0; i < result.length; i++) {
          result[i].eqs.sort(function (a, b) {
            let q = +a.CreatedTime.join(""), h = +b.CreatedTime.join("")
            return h - q;
          })
        }
        this.CaseDetailList = result;
      }
      
          }).catch(err => {
            console.log(err);
          })
      // if (e && e.stopPropagation) {
      //   e.stopPropagation();
      // } else {
      //   window.event.cancelBubble = true;
      // }
      // this.dialogVisible = !this.dialogVisible;//切换弹框显示状态
    },
    clickBox(e) {
      if (e && e.stopPropagation) {
        e.stopPropagation();
      } else {
        window.event.cancelBubble = true;
      }
    },
    goDetail(id) {
      let routeData = this.$router.resolve({ name: 'caseDetal', params: { id: id } });
      window.open(routeData.href, '_blank');
    },
    async getCaseDetail() {//在methods里面定义一个async方法
      // let res = await getCaseDetail({ id: this.info.id });//this.info.id是当前项的id，由父组件传过来
      // console.log(res)
      // if (res.Type == 'Success') {//成功接收的返回的数据
      //   //将数据存起来（data里面）
      //   let qe = res.Data.qe;
      //   //将YYYY-MM-dd hh:mm:ss的时间格式拆分成[YYYY,MM,dd,hh,mm,ss]数组
      //   qe = qe.map(value => {
      //     value.CreatedTime = value.CreatedTime.split(/[- :]/);
      //     return value;
      //   });

      //   //将qe里面的数据按年再次分组
      //   let result = [];
      //   //result期望结构如下
      //   /*[
      //       {
      //           year: "YYYY",
      //           qes:[qe]
      //       }
      //   ]*/
      //   qe.filter((value, index) => {
      //     //判断result是否已经包含该年的分组
      //     let exist = false;//默认不存在
      //     for (let i = 0; i < result.length; i++) {
      //       if (result[i].year === value.CreatedTime[0]) {//已经存在分组
      //         //将当前项加入该分组
      //         result[i].eqs.push(value);
      //         exist = true;//存在
      //         break;
      //       }
      //     }
      //     if (!exist) {//不存在，向result中加入该分组
      //       result.push({ year: value.CreatedTime[0], eqs: [value] })
      //     }
      //   });

      //   //对result进行第一层排序（年）
      //   result.sort(function (a, b) {
      //     return (+b.year) - (+a.year)
      //   });
      //   //对result进行第一层排序（月，日，时，分，秒）
      //   for (let i = 0; i < result.length; i++) {
      //     result[i].eqs.sort(function (a, b) {
      //       let q = +a.CreatedTime.join(""), h = +b.CreatedTime.join("")
      //       return h - q;
      //     })
      //   }
      //   this.CaseDetailList = result;
      // }
    }
  },
  mounted() {//组件创建完成后会执行这里面的代码
    this.getCaseDetail();//调用在methods里面定义的async方法

  }
};
</script>

<style scoped>
.itme:hover .look{
  background: #00b86d;
  color: #FFFFFF;
  border:none;
}
.look{
  width: 100px;
  height: 28px;
  color: #666666;
  border: 1px solid #969799;
  display: inline-block;
  float: right;
  margin-top: 4px;
  line-height: 27px;
  text-align: center;
  margin-right: 20px;
}
.JJe{
    margin-top: 13px;
    max-height: 34px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height:17px;
}
.GCh{
    max-height:inherit;
    -webkit-line-clamp: 1;
}
.GQi{
    max-height:inherit;
    -webkit-line-clamp: 1;
}
.itme h4 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #333333;
  margin-top: 20px;
  font-size: 16px;
  width: 305px;
}
.Box {
  margin-top: 170px;
  width: 550px;
  height: 700px;
  background-color: #fff;
}
.Box {
  overflow: auto;
}
.title {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px #d2d2d2 solid;
  font-weight: bold;
  color: #1a1a1a;
}
.Box > div {
  width: 94%;
  margin: 0 auto;
  position: relative;
}
.yearBox {
  width: 100%;
  padding-top: 10px;
  padding-left: 10px;
}
table {
  font-size: 13px;
  width: 100%;
  padding-top: 10px;
}
tr {
  height: 30px;
  color: #808080;
}
tr:hover {
  color: #ff5300;
}
tr > a {
  color: #808080;
  height: 30px;
}
tr > a:hover {
  color: #ff5300;
}
td {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.time {
  width: 15%;
}
.ZLAQScore,
.CLAQScore {
  width: 20%;
}
.explain {
  width: 45%;
}
.cover {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  top: 0;
  left: 0;
  z-index: 999;
}
.cover > div {
  position: relative;
  width: 550px;
  height: 570px;
  margin: 100px auto 0;
}
.itemImg>img{
    display: block;
    width: 100%;
    height: 100%;
    object-fit:cover;
}

.itme {
  vertical-align: top;
  border-radius: 4px;
  width: 575px;
  height: 240px;
  margin-right: 20px;
  margin-top: 25px;
  background: #FFFFFF;
  
  border-radius: 4px;
  float:left;
  -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -ms-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
    background-color: #fff;
}
.itme:hover {
  box-shadow: 0px 3px 21px 0px rgba(77, 77, 77, 0.15);
  
 
}

.itemImg {
  position: relative;
  width: 210px;
  height: 200px;
  bottom: 0;
  padding:20px;
  float: left;
}
.itemImg > img {

  top: 0;
  left: 0;
  width: 210px;
  height: 200px;
  
}
/*.itemImg > div {
  transition: all 0.3s;
  display: flex;
  position: absolute;
  bottom: -30px;
  left: 0;
  width: 270px;
  height: 30px;
}*/
/*.itemImg > div > div {
  opacity: 0.9;
  line-height: 30px;
  text-align: center;
  color: rgba(248, 250, 252, 1);
  flex: 1;
  border-right: 1px #f8fafc solid;
  background-color: #f15117;
}*/
.itemImg > div > div:nth-last-child(1) {
  border-right: none;
}

.ab{display:inline-block;}
.ab:nth-child(2n) .itme {
  margin-right:0px;
}
.itme > p {
  color: #999999;
  margin: 0 20px 0 9px;
}
.itme:hover .itemImg > div {
  bottom: 0 !important;
}
</style>
